import {
  Archive,
  BookOpen,
  CalendarCheck,
  Circle,
  Cloud,
  Eye,
  Folder,
  Inbox,
  Layers,
  RefreshCcw,
  Trash2,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * Icons of the sidebar (docs/05 §7.5): Lucide, imported one by one so the bundle only carries
 * these. The template names each view's icon (`views.icon`); an unknown name falls back to a
 * neutral circle instead of breaking the row.
 */

const BY_NAME: Record<string, LucideIcon> = {
  inbox: Inbox,
  zap: Zap,
  layers: Layers,
  cloud: Cloud,
  eye: Eye,
  folder: Folder,
  book: BookOpen,
  archive: Archive,
  'calendar-check': CalendarCheck,
  trash: Trash2,
};

const SIZE = 18;
/** Stroke of docs/05 §7.5 (1.8 px on a 24 px grid). */
const STROKE = 1.8;

export function ViewIcon({ name }: { name: string | null }) {
  const Icon = (name ? BY_NAME[name] : undefined) ?? Circle;
  return <Icon size={SIZE} strokeWidth={STROKE} aria-hidden="true" />;
}

export function RitualIcon() {
  return <RefreshCcw size={SIZE} strokeWidth={STROKE} aria-hidden="true" />;
}
